<dx-date-range-box
  startDateLabel="Début"
  endDateLabel="Fin"
  [showClearButton]="true"
  (onValueChanged)="onValueChanged($event)"
  width="275"
  [height]="'auto'"
  [(value)]="selectedDates"
>
</dx-date-range-box>
<dx-data-grid
  [dataSource] = "popularityHistory"
  columnResizingMode="widget"
  [allowColumnReordering]="true"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  class="dx-data-grid"
>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-grouping
    [contextMenuEnabled]="true"
    expandMode="rowClick"
  ></dxo-grouping>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxi-column dataField="uniteProductionLibelle" caption="Unite de Production" [filterOperations]="['contains']"></dxi-column>
  <dxi-column dataField="produitDeclineLibelle" caption="Nom du plat" [filterOperations]="['contains']"></dxi-column>
  <dxi-column dataField="declinaisonLibelle" caption="Déclinaison"></dxi-column>
  <dxi-column dataField="prestationLibelle" caption="Prestation" [filterOperations]="['contains']"></dxi-column>
  <dxi-column dataField="regimeLibelle" caption="Régime" [filterOperations]="['contains']"></dxi-column>
  <dxi-column dataField="dateMenu" caption="Date de conso" dataType="date" [filterOperations]="['contains']"></dxi-column>
</dx-data-grid>
